var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.prefixCls,attrs:{"id":"scrollContainer"}},[_c('transition',{attrs:{"name":"custom","mode":"out-in","appear":""}},[_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }